module.exports = __webpack_public_path__ + "static/media/download_src_5.6b74964c.jpg";